<template>
    <div class="exams-main">
        <div class="hasCategory ">
            <div class="exams-panel">
                 <div class="exams-panel-body">
                        <div class="table-toolbar flex align-cen">
                            <div class="table-toolbar-left flex align-cen">
                                <div class="now-exam btnexam" :class="textActive == '0' ? 'btnactive' : ''" @click="swichTopic(0)">正式考试</div>
                                <div class="log-exam btnexam" :class="textActive == '1' ? 'btnactive' : ''" @click="swichTopic(1)">练习考试</div>
                            </div>
                            <div class="table-toolbar-right mft flex align-cen">
                                <div class="regulaOption">
                                    <el-select v-model="regulaTagValue"  clearable placeholder="考试状态"
                                   @change="getcenChan"
                                    >
                                        <el-option
                                        v-for="item in regulaTag"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.state">
                                        </el-option>
                                    </el-select>
                                </div>
                                   <!-- <div class="regulaOption" v-if="btnactive == 1">
                                    <el-select v-model="regulaTagValue2"  clearable placeholder="分数"
                                    @change="getcenChan1"
                                    >
                                        <el-option
                                        v-for="item in regulaTag2"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.state">
                                        </el-option>
                                    </el-select>
                                </div> -->
                                <!-- @change="btnactive == 0 ? getCentList() : getCentList1()" -->
                                   <div class="regulaOption">
                                    <el-select v-model="regulaTagValueclass"  placeholder="考试分类"
                                    @change="getListClass"
                                    >
                                        <el-option
                                        v-for="item in regulaTag1"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.state"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>

                            </div>
                        </div>
                        <div class="exams-list">
                            <div class="onlineExam" v-if="onlineExam">
                                <!-- 在线考试 -->
                               <div class="public-tit flex align-cen" style="margin:10px 16px">
                                    <div class="public-tit-list">
                                        <i class="icon-al-file-fill"></i>  在线考试
                                    </div>
                                </div>
                              <div class="exams-scrollbar flex" v-if="examList.length">
                                 <!-- -->
                                <div class="exams-item" v-for="(item,index) in examList" >
                                    <div class="exams-item-paperName">
                                        {{item.paperName}}
                                    </div>
                                    <div class="exams-item-info flex">
                                        <img :src="item.logo" alt="">
                                        <div class="exams-item-info-rule">
                                            <div>
                                            <p v-if="item.validPeriod == '2'" class="flex">考试时间：<span class="mft">永久有效</span></p>
                                            <p v-if="item.validPeriod == '1'" class="flex">考试时间：
                                                <el-tooltip class="item" effect="dark" :content="`${item.showFromTime}~${item.showUntilTime}`" placement="top"> 
                                                <span class="mft">
                                                    {{item.showFromTime}}~{{item.showUntilTime}}
                                                </span>
                                               </el-tooltip>
                                            </p>
                                           <p class="flex align-cen">考试次数：
                                            <span class="mft">
                                                {{getAanswerNumType(item.answerNumType,item.answerNum,1)}}
                                            </span>
                                           </p>
                                           <p class="flex">
                                            考试限时:
                                            <span class="mft" v-if="item.validPeriod == '2'">{{item.timeLimit}}分钟</span>
                                            <span class="mft" v-else>-</span>
                                           </p>
                                           <p class="flex">
                                            考试总分:
                                            <span class="mft">{{item.paperScore}}分</span>
                                           </p>
                                           <p class="flex">
                                            及格分数:
                                            <span class="mft">{{item.passmark}}%</span>
                                           </p>
                                           </div>
                                           <!-- <div v-if="btnactive == 1">
                                             <p  class="flex">考试时间：
                                                <span class="mft">{{item.startTime}}</span>
                                             </p>
                                             <p  class="flex">用时：
                                                <span class="mft">{{convertSecondsToMinutes(item.doTime,1)}}</span>
                                             </p>
                                             <p  class="flex">得分比：
                                                <span class="mft">{{Number(item.scoreRate)}}%</span>
                                             </p>
                                           </div> -->
                                     <div class="tipImg">
                                        <img src="../../assets/images/examNow.png" alt="" v-if="item.state == 1" class="jxz">
                                         <img src="../../assets/images/examno.png" alt="" v-if="item.state == 0">
                                          <img src="../../assets/images/examend.png" alt="" v-if="item.state == 2">

                                    </div>
                                     <!-- <div class="tipImg" v-if="btnactive == 1">
                                        <img src="../../assets/images/exampass.png" alt="" v-if="item.result == 1">
                                         <img src="../../assets/images/examnopass.png" alt="" v-if="item.result == 0">
                                          <img src="../../assets/images/pjz.png" alt="" v-if="item.result == 2">
                                    </div> -->
                                        </div>
                                    </div>
                                    <div class="exams-item-line"></div>
                                    <div class="flex" style="justify-content:end">
                                        <div class="exams-item-btn" v-if="item.state == 1" @click="openExamlogin(item)">进入考试</div>
                                         <div class="exams-item-btn exams-item-btn1" v-if="item.state == 2">已考完</div>
                                          <div class="exams-item-btn exams-item-btn1" v-if="item.state == 0">未开始</div>
                                    </div>
                                    <!-- <div class="flex" style="justify-content:end" v-if="btnactive ==1">
                                        <div class="exams-item-btn" @click="getResulttRanscript(item)">查看成绩</div>
                                    </div> -->
                                </div>
                            </div>
                            <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                            </div>
                            <div class="RasoExam" v-if="RasoExam">
                                <!-- 仿真考试 -->
                                  <div class="public-tit flex align-cen" style="margin:10px 16px">
                                    <div class="public-tit-list">
                                        <i class="icon-al-file-fill"></i>  仿真考试
                                    </div>
                                </div>
                                    <div class="exams-scrollbar flex" v-if="examList1.length">
                                 <!-- -->
                                <div class="exams-item" v-for="(item,index) in examList1" >
                                    <div class="exams-item-paperName">
                                        {{item.paperName}}
                                    </div>
                                    <div class="exams-item-info flex">
                                        <img :src="item.logo" alt="">
                                        <div class="exams-item-info-rule">
                                            <div>
                                            <p v-if="item.validPeriod == '2'" class="flex">考试时间：<span class="mft">永久有效</span></p>
                                            <p v-if="item.validPeriod == '1'" class="flex">考试时间：
                                                <el-tooltip class="item" effect="dark" :content="`${item.showFromTime}~${item.showUntilTime}`" placement="top"> 
                                                <span class="mft">
                                                    {{item.showFromTime}}~{{item.showUntilTime}}
                                                </span>
                                               </el-tooltip>
                                            </p>
                                           <p class="flex align-cen">考试次数：
                                            <span class="mft">
                                                {{getAanswerNumType(item.answerNumType,item.answerNum,1)}}
                                            </span>
                                           </p>
                                           <p class="flex">
                                            考试限时:
                                                 <span class="mft" v-if="item.validPeriod == '2'">{{item.timeLimit}}分钟</span>
                                            <span class="mft" v-else>-</span>
                                           </p>
                                           <p class="flex">
                                            考试总分:
                                            <span class="mft">{{item.paperScore}}分</span>
                                           </p>
                                           <p class="flex">
                                            及格分数:
                                            <span class="mft">{{item.passmark}}%</span>
                                           </p>
                                           </div>
                                           <!-- <div v-if="btnactive == 1">
                                             <p  class="flex">考试时间：
                                                <span class="mft">{{item.startTime}}</span>
                                             </p>
                                             <p  class="flex">用时：
                                                <span class="mft">{{convertSecondsToMinutes(item.doTime,1)}}</span>
                                             </p>
                                             <p  class="flex">得分比：
                                                <span class="mft">{{Number(item.scoreRate)}}%</span>
                                             </p>
                                           </div> -->
                                     <div class="tipImg">
                                        <img src="../../assets/images/examNow.png" alt="" v-if="item.state == 1" class="jxz">
                                         <img src="../../assets/images/examno.png" alt="" v-if="item.state == 0">
                                          <img src="../../assets/images/examend.png" alt="" v-if="item.state == 2">

                                    </div>
                                     <!-- <div class="tipImg" v-if="btnactive == 1">
                                        <img src="../../assets/images/exampass.png" alt="" v-if="item.result == 1">
                                         <img src="../../assets/images/examnopass.png" alt="" v-if="item.result == 0">
                                          <img src="../../assets/images/pjz.png" alt="" v-if="item.result == 2">
                                    </div> -->
                                        </div>
                                    </div>
                                    <div class="exams-item-line"></div>
                                    <div class="flex" style="justify-content:end" >
                                        <div class="exams-item-btn" v-if="item.state == 1" @click="openExamlogin1">进入考试</div>
                                         <div class="exams-item-btn exams-item-btn1" v-if="item.state == 2">已考完</div>
                                          <div class="exams-item-btn exams-item-btn1" v-if="item.state == 0">未开始</div>
                                    </div>
                                    <!-- <div class="flex" style="justify-content:end" v-if="btnactive ==1">
                                        <div class="exams-item-btn" @click="getResulttRanscript1(item)">查看成绩</div> 
                                    </div> -->
                                </div>
                            </div>
                             <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
            <!-- 查看成绩单 -->
      <el-dialog
  title="查看成绩单"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass paperDialogClass"
  v-if="centerDialogVisible"
  >
    <el-tabs  v-model="activeName">
        <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo.paperName}}</p>
                    <p class="text">考试者：{{testerInfo.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo.startTime}} | 交卷时间：{{testerInfo.answerTime}} 
                    </p>
                 <div class="sorceRow">
                        <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo.result !=2">
                                <p class="score-num">{{testerInfo.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf">(试卷总分{{testerInfo.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{convertSecondsToMinutes(testerInfo.doTime,2)}}</div>
                                  
                             <div class="pass-message">
                                <!-- <div class="public-tit flex align-cen">
                                    <div class="public-tit-list">
                                        <i class="icon-al-question-circle"></i> 
                                    </div>
                                </div> -->
                                <p >
                                    <span> 教师评语：</span>
                                    <span v-html="testerInfo.comment || '无'"></span>
                                </p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio" @change="getQuestionListCom(radio)">
      <el-radio-button label="1">
        答对（{{testerInfo.rightNum}}）
      </el-radio-button>
        <el-radio-button label="5" v-if="testerInfo.result == 2">
        未批改（{{testerInfo.uncorrectedNum}}）
        </el-radio-button>
      <el-radio-button label="2">
        答错（{{testerInfo.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        未答（{{testerInfo.unAnswerNum}}）
      </el-radio-button>
      <el-radio-button label="4">
        全部试题（{{testerInfo.questionNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList.length">
                    <div class="row" v-for="(item,index) in questionList" :key="item.id">
                        <div class="ques-title">
                            <span class="ques-number">{{index+1}}.</span>
                            <span class="ques-type">
                                {{$util.getTopicType(item.type)}}
                            </span>
                            <span v-html="item.title" :class="item.type == 9 ? 'clozeClass' : ''"></span>
                            <span class="ques-score">（{{item.questionScore}}分）</span>
                        </div>
                          <div class="question-option-list">
                            <ol v-if="item.type != 9 && item.type != 5">
                                <li v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                             <div class="refAnswer"  v-if="item.type == 5" style="margin-left:-25px">
                              <div class="detailKeyWorld" v-if="item.rule">
                                  <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                  <p>关键字：</p>
                                      <p v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                      {{sonitem.content}}<span v-if="sonIndex !=item.questionAnswerList.length-1">，</span>
                                  </p>
                                  </div>
                              </div>
                              <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                          </div>
                            <div class="clzoe" v-if="item.type == 9">
                                <div class="clzoeItem" v-for="(sonitem,sonIndex) in item.questionAnswerList" :key="sonIndex">
                                <p class="cloze-op-p" style="margin-left:-25px">
                                    <strong> {{sonIndex + 1}}:</strong>
                                </p>
                                <ol >
                                    <li  v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                        <p v-html="sonitem1.content"></p>
                                    </li>
                                </ol>
                                </div>
                            </div>
                          </div>
                        <div class="ques-answers">
                            <div class="test_result flex align-cen">
                                <div class="userAnswer">
                                    <div class="test_result_span_title">考生答案：</div>
                                    <strong :class="item.doRight == 1 ? 'true' : 'false'" v-if="item.isAnswer == '1'">
                                        {{item.answerContent}}
                                        <i :class="item.doRight == 1 ? 'icon-al-check' : 'icon-al-times'" v-if="radio != 5"></i>
                                    </strong>
                                    <span v-else>未作答</span>
                                </div>
                                <div class="rightAnswer" v-if="item.type != 7 && item.type != 9 && item.type != 5">
                                     <div class="test_result_span_title">正确答案：</div>
                                        <div class="dnl flex">
                                            <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                        <strong  v-if="sonitem.isRight == 1">
                                        {{Eng[sonIndex]}}
                                    </strong>
                                    </span>
                                    </div>
                                </div>
                                   <div v-if="item.type == 5" class="rightAnswer" style="color:#009aff">
                                         <div class="test_result_span_title">参考答案：</div>
                                  <span v-html="item.refAnswer"></span>
                                </div>
                                 <div v-if="item.type == 7" class="rightAnswer">
                                        <div class="test_result_span_title">正确顺序：</div>
                                    <span v-for="(sonitem,sonIndex) in item.sortedIndexes">
                                        <span>
                                        {{Eng[sonitem]}}
                                    </span>
                                    </span>
                                </div>
                                  <div v-if="item.type == 9" class="rightAnswer">
                                    <div class="test_result_span_title">正确答案：</div>
                                    <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                                <span style="margin-right:20px">
                                                {{sonIndex + 1}}:
                                                <span v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                                    <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                                </span>
                                                </span>
                                    </span>
                                </div>
                                <div class="score">
                                    <div class="test_result_span_title">分数：</div>
                                    <strong style="color: #36aafd">
                                        {{item.customerScore}} / {{item.questionScore}}分
                                    </strong>
                                </div>
                            </div>
                        </div>
                          <div class="jx flex align-cen">
                            题目解析：<span v-html="item.analysis || '暂无解析'"></span>
                         </div>
                    </div>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        </el-tabs>
      <div class="info-row flex align-cen">
         <!-- <span class="info-col-left flex align-cen"> 
            <i class="icon-al-share"></i>分享
         </span> -->
         <span class="info-col-right felx align-cen mft">
            <span class="pc-wc-share" @click="sharePaper">
                 <el-tooltip placement="left" class="item" effect="dark" content="查看分享海报" popper-class="silderMenu-tips"  >
                <i class="icon-al-qrcode"></i>
                 </el-tooltip>
            </span>
                
             <span class="pc-wc-share" @click="copyLink">
                <el-tooltip placement="left" class="item" effect="dark" content="复制链接" popper-class="silderMenu-tips"  >
                <i class="icon-al-link"></i>
                  </el-tooltip>
            </span>
         </span>
        </div>
      </el-dialog>
           <!-- 打开仿真成绩单 -->
            <el-dialog
  title="查看成绩单"
  :visible.sync="centerDialogVisible1"
  width="40%"
  :append-to-body="true"
  center
  custom-class="paperDialogClass publicDialogClass"
  v-if="centerDialogVisible1"
  >
    <el-tabs  v-model="activeName1">
        <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo1.paperName}}</p>
                    <p class="text">考试者：{{testerInfo1.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo1.startTime}} | 交卷时间：{{testerInfo1.answerTime}} 
                    </p>
                    <div class="sorceRow">
                         <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo1.result !=2">
                                <p class="score-num">{{testerInfo1.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf"  v-if="testerInfo1.result !=2">(总分{{testerInfo1.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo1.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{$util.convertSecondsToMinutes(testerInfo1.doTime,2)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio1" @change="getQuestionListCom1(radio1)">
      <el-radio-button label="1">
        答错（{{testerInfo1.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="2">
        得分（{{testerInfo1.rightNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        全部步骤（{{testerInfo1.stepNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList1.length">
                       <div class="public-tit flex align-cen" style="margin-bottom:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-database-fill"></i>  过程
                      </div>
                  </div>
                           <el-table
                    :data="processList"
                    border
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                        <el-table-column prop="processName" label="过程名称" align="center" >
                        </el-table-column>
                         <el-table-column  label="起始条件"  width="300">
                          <template slot-scope="scope">
                            <div class="flex justify-content-cen">
                              <div v-for="(item,pindex) in scope.row.startCondition" :key="pindex" class="flex ">
                                 <span class="textR">{{item.cond1}}</span>{{item.tag}} {{item.name}}{{item.tj}}{{item.tj1}}
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                          <el-table-column  label="结束条件"  width="300">
                            <template slot-scope="scope">
                            <div class="flex justify-content-cen">
                              <div v-for="(item,pindex) in scope.row.endCondition" :key="pindex" class="flex">
                                <span class="textR">{{item.cond1}}</span>{{item.tag}} {{item.name}}{{item.tj}}{{item.tj1}}
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                </el-table>
                        <div class="public-tit flex align-cen" style="margin:10px 0">
                      <div class="public-tit-list">
                          <i class="icon-al-database-fill"></i>  步骤
                      </div>
                  </div>
                          <el-table
                    :data="questionList1"
                    border
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                        <el-table-column prop="processName" label="关联过程" align="center" >
                        </el-table-column>
                         <el-table-column  prop="stepName" label="步骤名称" align="center">
                        </el-table-column>
                          <el-table-column  label="得分"  align="center">
                            <template slot-scope="scope">
                             <span class="textR"> {{scope.row.customerScore}}</span> / <span>{{scope.row.score}}</span>
                          </template>
                        </el-table-column>
                </el-table>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        </el-tabs>
            <div class="info-row flex align-cen">
         <!-- <span class="info-col-left flex align-cen"> 
            <i class="icon-al-share"></i>分享
         </span> -->
         <span class="info-col-right felx align-cen mft">
            <span class="pc-wc-share" @click="sharePaper1">
                 <el-tooltip placement="left" class="item" effect="dark" content="查看分享海报" popper-class="silderMenu-tips"  >
                <i class="icon-al-qrcode"></i>
                 </el-tooltip>
            </span>
                
             <span class="pc-wc-share" @click="copyLink1">
                <el-tooltip placement="left" class="item" effect="dark" content="复制链接" popper-class="silderMenu-tips"  >
                <i class="icon-al-link"></i>
                  </el-tooltip>
            </span>
         </span>
        </div>
      </el-dialog>
 <el-dialog
  title="分享成绩单"
  :visible.sync="centerDialogVisible3"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw :propImg="propImg" :propText="propText" :propQrcode="link" :dowloadImgName="dowloadImgName" ref="posterEmit"></posterDraw>
</el-dialog>
 <el-dialog
  title="分享仿真成绩单"
  :visible.sync="centerDialogVisible2"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw :propImg="propImg" :propText="propText1" :propQrcode="link1" :dowloadImgName="dowloadImgName1" ref="posterEmit1"></posterDraw>
</el-dialog>
    </div>
</template>
<script> 
import {centList,centLog,resulttRanscript,exercisesList,rasocentLog,rasoResulttRanscript} from "@/api/enterprise/index"   //考试列表、考试记录、仿真考试列表，仿真考试记录
import mycomponents from "@/utils/compoments.js"
import examSidebar from "../../layout/components/examSidebar.vue"
export default {
    name:'testingCenter',
    components:{
      posterDraw:mycomponents.components.posterDraw,
      examSidebar
    },
    data () {
        return {
        onlineExam:true,
        RasoExam:true,
         dowloadImgName:'成绩单',
         dowloadImgName1:'仿真成绩单',
          propData:{},
          propData1:{},
            propImg:'https://oss.yhkz.com/2024-05-25/%E6%88%91%E7%9A%84%E8%80%83%E8%AF%95%20(2)_20240525134806.jpg',
            propText:'',
            link:'',
          centerDialogVisible3:false,
           propText1:'',
            link1:'',
          centerDialogVisible2:false,
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            centerDialogVisible:false,
            radio:'1',
            questionList:[],
            resultQuestionVOList:[],
            testerInfo:{},
            activeName:'1',
            centerDialogVisible1:false,
            radio1:'1',
            questionList1:[],
            resultQuestionVOList1:[],
            testerInfo1:{},
            activeName1:'1',
             stepList:[],
          processList:[],
            examList:[],
            examList1:[],
            businessInfo:{},
            regulaTag:[
                 {
                    state:'',
                    name:'全部'
                },
                {
                    state:'0',
                    name:'未开始'
                },
                {
                    state:'1',
                    name:'考试中'
                },
            ],
            regulaTag1:[

                {
                    state:'',
                    name:'全部'
                },
                {
                    state:'1',
                    name:'在线考试'
                },
                {
                    state:'2',
                    name:'仿真考试'
                },
            ],
             regulaTag2:[
                {
                    state:'',
                    name:'全部'
                },
                {
                    state:'0',
                    name:'未通过'
                },
                {
                    state:'1',
                    name:'已通过',
                },{
                    state:'2',
                    name:'批卷中',
                },
            ],
            regulaTagValue:'',
            regulaTagValue1:'0',
            regulaTagValue2:'',
            regulaTagValueclass:'',
            title:'考试中心',
            btnactive:0,
            textActive:0,
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            options:[
                {
                    name:'正式考试',
                    id:0
                },
                {
                  name:'练习考试',
                  id:1   
                }
            ]
        }
    },
    created() {
        document.title = '考试中心'
         if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
         this.getCentList()
         this.getrasoCentList()
    },
    methods: {
        getcenChan(){
         this.getCentList()
         this.getrasoCentList()
        },
         getcenChan1(){
         this.getCentList1()
         this.getrasoCentList1()
        },
        // 仿真在线切换
        getListClass(){
        if(this.regulaTagValueclass == 1){
            this.examList1 = []
            this.onlineExam = true
            this.RasoExam = false
             this.getCentList()
        //    if(this.btnactive ==0){
            
        //    }else{
        //     this.getCentList1()
        //    }
        }else if(this.regulaTagValueclass == 2){
              this.examList = []
              this.onlineExam = false
            this.RasoExam = true
            this.getrasoCentList()
        //    if(this.btnactive ==0){
             
        //    }else{
        //     this.getrasoCentList1()
        //    }
        }else{
            this.onlineExam = true
            this.RasoExam = true
                this.getCentList()
             this.getrasoCentList()
        //     if(this.btnactive ==0){
        
        //    }else{
        //     this.getCentList1()
        //     this.getrasoCentList1()
        //    }
        }
        },
              convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
        // 判断是否为选择题
        getQueType(type){
        },
        // 获取考试次数
        getAanswerNumType(type,num,fnType){
            // fnType = 1 表示考试次数、 2、表示题型判断
            const actionTypelanes = {
                0:'无限次',
                1:fnType == 1 ? '一次' : fnType == 2 ? '单选题' : '',
                2:fnType == 1 ? `多次（${num}次）` : fnType == 2 ? '多选题' : '',
                3:fnType == 1 ? `每天每人（${num}）次` : fnType == 2 ? '判断题' : '',
                4:fnType == 1 ? '' : fnType == 2 ? '填空题' : ''
            }
            return actionTypelanes[type] || ''
        },
        // 打开进入考试
        openExamlogin(data){
             this.$router.push({
            name:'examLogin',
            query:{
                id:data.paperId,
                businessId:this.businessInfo.id
            }
            })
        },
        // 打开进入仿真考试
        openExamlogin1(){
        this.$confirm('您选择的是仿真考试，请您使用HeroSim，打开对应仿真系统，参与考试', '考试提示', {
          confirmButtonText: '去下载HeroSim',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            const newurl = this.$router.resolve({name: 'endowloadDetail', query: {id: 'RASO20220930001',type:2}})
            window.open(newurl.href,'_blank')
        })
        },
                convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
                   copyLink(){
     let _self = this
      this.$copyText(this.link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
        },
        sharePaper(){
            this.centerDialogVisible3 = true
              this.$nextTick(() => {
                 this.$refs.posterEmit.handleChangeImg(this.propData) 
              })
           
        },
                     copyLink1(){
     let _self = this
      this.$copyText(this.link1).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
        },
        sharePaper1(){
            this.centerDialogVisible2 = true
              this.$nextTick(() => {
                 this.$refs.posterEmit1.handleChangeImg(this.propData1) 
              })
           
        },
           // 获取成绩单
        getResulttRanscript(data){
            this.centerDialogVisible = true
            this.activeName = '1'
            this.resultQuestionVOList = []
            this.questionList = []
            this.radio = '1'
            resulttRanscript({id:data.resultId}).then(res => {
                this.testerInfo = res.data
                this.resultQuestionVOList = res.data.resultQuestionVOList
                          this.propData = data
                this.propText =  `考生：${res.data.examiner}`
                this.dowloadImgName = res.data.examiner
                this.link = this.$config.prUrl + '#/myExam/transcriptExam?resultId=' + data.resultId + '&type=2'
                        this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
                this.resultLogList = res.data.resultLogList
                this.getQuestionListCom(1)
            })
        },
           getQuestionListCom(type){
            this.questionList = []
                this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
          if(type == 1){
            for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 2){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 3){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 4){
                this.questionList = this.resultQuestionVOList
             }else if(type == 5){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].doRight =='2' && this.resultQuestionVOList[key].isAnswer =='1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
             }else{
                this.questionList = []
             }
        },
      // 获取仿真成绩单
        getResulttRanscript1(data){
            console.log(data)
          this.centerDialogVisible1 = true
            this.activeName1 = '1'
             this.radio1 = '1'
           this.processList = []
            this.stepList = []
            this.questionList1 = []
            rasoResulttRanscript({id:data.resultId}).then(res => {
                  this.propData = data
                 this.propText1 =  `考生：${res.data.examiner}`
                this.dowloadImgName1 = res.data.examiner
                this.link1 = this.$config.prUrl + '#/myExam/transcriptExam1?resultId=' + data.resultId + '&type=2'
                this.testerInfo1 = res.data
                this.resultQuestionVOList1 = res.data.resultQuestionVOList
                let newarr = ['startCondition','endCondition']
                this.processList = res.data.processList
                this.processList.forEach(item =>{ 
                newarr.forEach((t,index) =>{
                let str = item[t]
                    let arr = []
                    str = str.trim().replace(/;$/, '');  
                    arr = str.split(';')
                   item[t] = arr.map(item =>{
                        // 分割字符串为数组，
                        let parts = item.split(',');
                        // 构造对象  
                            return {  
                                cond1: parts[0],  
                                tag: parts[1],  
                                name: parts[2],  
                                tj: parts[3],  
                                tj1: parts[4]  
                            };
                    })
                    })
                })
                this.stepList = res.data.stepList
                this.getQuestionListCom1(1)
            })
        },
                getQuestionListCom1(type){
            this.questionList1 = []
          if(type == 1){
            for (let  key in this.stepList) {
           if(this.stepList[key].stepState != 11){
                this.questionList1.push(this.stepList[key])
             }
            }
        }else if(type == 2){
          console.log(2)
             for (let  key in this.stepList) {
           if(this.stepList[key].stepState == 11){
                this.questionList1.push(this.stepList[key])
             }
            }
        }else if(type == 3){
                this.questionList1 = this.stepList
             }else{
                this.questionList1 = []
             }
        },
        // 获取考试列表
        getCentList(){
            let params = {
                businessId:this.businessInfo.id,
                state:this.regulaTagValue,
                practiceMode:this.regulaTagValue1,
                result:this.regulaTagValue2,
            }
            centList({...params})
            .then(res =>{
                this.examList = res.data
            })
        },
           // 获取仿真考试列表
        getrasoCentList(){
            let params = {
                businessId:this.businessInfo.id,
                state:this.regulaTagValue,
                practiceMode:this.regulaTagValue1,
                result:this.regulaTagValue2,
            }
            exercisesList({...params})
            .then(res =>{
                this.examList1 = res.data
            })
        },
        // 获取记录
          getCentList1(){
            let params = {
                businessId:this.businessInfo.id,
                state:this.regulaTagValue,
                practiceMode:this.regulaTagValue1,
                result:this.regulaTagValue2,
            }
            centLog({...params})
            .then(res =>{
                this.examList = res.data
            })
        },
        // 获取仿真记录
          getrasoCentList1(){
            let params = {
                businessId:this.businessInfo.id,
                state:this.regulaTagValue,
                practiceMode:this.regulaTagValue1,
                result:this.regulaTagValue2,
            }
            rasocentLog({...params})
            .then(res =>{
                this.examList1 = res.data
            })
        },
        swichTopic(index){
            this.examList = []
            this.examList1 = []
            this.textActive = index
            this.regulaTagValue1 = index
            this.getCentList()
            this.getrasoCentList()
        },
        // addclass(index){
        //     this.btnactive = index
        //        this.regulaTagValue2 =''
        //         this.result = ''
        //         this.practiceMode = '0'
        //         this.regulaTagValue = ''
        //         this.regulaTagValueclass = ''
        //     this.onlineExam = true
        //     this.RasoExam = true
        //     if(index == 0){
        //         this.getCentList()
        //         this.getrasoCentList()
        //     }else{
        //         this.getCentList1()
        //         this.getrasoCentList1()
        //     }
        // },
    },
}
</script>
<style lang="scss" scoped>
.watermark{
    .question{
        margin-top: 50px;
        .question-main-content{
            .row{
                .ques-title{
                    vertical-align: middle;
                    -webkit-margin-before: 0;
                    -webkit-margin-after: 0;
                    word-break: break-word; 
                   .ques-number,.ques-type{
                    color: #36aafd;
                   } 
                   .ques-score{
                    color: #aeaeae;
                   }
                }
                .ques-answers{
                    margin-top: 15px;
                    .test_result{
                        justify-content: space-between;
                       .userAnswer{
                            color: #666;
                            min-width: 100px;
                            .true{
                                color: green;
                                font-size: 16px;
                            }
                            .false{
                                color: red;
                                font-size: 16px;
                            }
                        }
                        .score{
                            min-width: 50px;
                            margin-left: 20px;
                        }
                        .dnl{
                            span{
                               color: #36aafd
                            }
                        }
                    }
                }
                .jx{
                    color: #999;
                        padding-top: 10px;
                }
            }
        }
    }
}
.print-tab-content{
    margin-top: 20px;
    .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: #333;
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                //    .UserNum{
                //     position: absolute;
                //     top: 0; 
                //     right: 0;
                //     .pbot{
                //         font-size: 14px;
                //     }
                //    }
                }
            }
        }
    }
}
.exams-main{
    height: inherit;
}
.hasCategory{
    height: inherit;
    .categories-panel{
        width: 300px;
        height: inherit;
        .portlet-title{
            display: flex;
            align-items: center;
            height: 74px;
            padding: 24px 12px 24px 24px;
            box-sizing: border-box;
            .caption{
                font-size: 20px;
                font-weight: bold;
            }
        }
        .portlet-body{
            position: relative;
            padding: 0 12px 24px 24px;
            .portlet-body-tip{
                position: relative;
                padding: 0;
                margin-bottom: 20px;
                .title{
                   font-size: 16px;
                color: #333;
                }
            }
            .categories-tree-item{
                position: relative;
                padding: 0 10px;
               .jstree-node:first-of-type{
                margin-top: 30px;
               }
               .treeactive{
                background: #f5fbff!important;
                border-radius: 4px;
               }
                .jstree-node{
                    cursor: pointer;
                    margin-top: 10px;
                    padding-left: 30px;
                    height: 24px;
                    .jstree-icon{
                        display: block;
                       width: 24px;
                        height: 24px;
                        line-height: 24px; 
                        background: url('../../assets/images/tree-default.svg') no-repeat center;
                    }
                    span{
                        padding-left: 12px;
                    }
                }

            }
        }
    }
    .exams-panel{
        position: relative;
        .exams-panel-body{
            position: relative;
            .table-toolbar{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 52px;
                margin-bottom: 0;
                padding: 0 16px;
                box-shadow: 0px 3px 6px 0px rgba(51, 51, 51, 0.1);
                z-index: 10;
                margin-bottom: 16px !important;
                .table-toolbar-left{
                    .btnexam{
                    height: 36px;
                    line-height: 36px;
                    padding: 0px 18px;
                    border-radius: 4px!important;
                    text-decoration: none!important;
                    white-space: nowrap;
                    cursor: pointer;
                     border: 1px solid #e4e4e4;
                    color: #36aafd;
                    border-color: #36aafd;
                    box-sizing: border-box;
                    line-height: 36px;
                    margin-right: 20px;
                    }
                    .btnactive{
                        background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%)!important;
                        color: #fff !important;
                    }
                }
                  .regulaOption{
                    width: 120px;
                    margin-right: 20px;
                  }
            }
            .exams-list{
                position: relative;
                .exams-scrollbar{
                    padding: 0 16px;
                    justify-content: space-between;
                        flex-wrap: wrap;
                    .exams-item{
                        margin-bottom: 16px;
                        padding: 16px 24px;
                        border-radius: 3px;
                        border: solid 1px #e6e6e6;
                        width: 44%;
                        position: relative;
                       .exams-item-paperName{
                        line-height: 30px;
                        margin: 0 16px 0 0;
                        font-size: 20px;
                        font-weight: 700;
                        color: #333!important;
                        transition: color 0.3s;
                        cursor: pointer;
                        word-break: break-all;
                       }
                       .exams-item-info{
                        margin: 10px 0;
                        img{
                            width: 220px;
                            height: 140px;
                        }
                        .exams-item-info-rule{
                            flex: 1;
                            padding: 0 15px;
                            color: #999;
                            width: calc(100% - 220px);
                            position: relative;
                            p{
                                margin-bottom: 10px;
                                padding-bottom: 5px;
                                border-bottom: 1px solid #e6e6e6;
                                 white-space: nowrap;  
                                overflow: hidden;  
                                text-overflow: ellipsis;
                            }
                            .tipImg{
                                position: absolute;
                                top: 25px;
                                left: 50%;
                                transform: translateX(-50%);
                                img{
                                  width: 154px;
                                  height: 122px;
                                transform: rotate(-45deg); 
                                
                                }
                                .jxz{
                                         width: 84px;
                                  height: 82px;
                                transform: rotate(-45deg); 
                                opacity: .2;
                                }
                            }
                        }
                       }
                       .exams-item-line{
                          border-bottom: 1px solid #e6e6e6;
                       }
                       .exams-item-btn{
                        background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%) !important;
                        color: #fff;
                        height: 36px;
                        padding: 0px 18px;
                        border-radius: 4px !important;
                        text-decoration: none !important;
                        white-space: nowrap;
                        cursor: pointer;
                        border: 1px solid #e4e4e4;
                        box-sizing: border-box;
                        line-height: 36px;
                        margin-right: 20px;
                        width: 120px;
                        text-align: center;
                        margin: 20px 0 0 0;
                       }
                       .exams-item-btn1{
                         background-image: linear-gradient(60deg, #e6e6e6 0%, #e6e6e6 100%) !important;
                         color: #999;
                       }
                    }
                             .exams-item:hover{
            border: 1px solid #36aafd;
        }
                }
            }
        }
    }
}
::v-deep{
         .clozeClass{
    p{
        display: inline-block !important;
      }
  }
       .regulaOption{
        margin-left: 20px;
                    .el-input__inner{
                        height: 34px !important;
                    }
    }
            .el-menu{background: none !important;border: none !important;}
.el-submenu,.el-menu-item,.el-submenu__title,.el-menu-item [class^=el-icon-],.el-submenu [class^=el-icon-] {
  color: #fff;
}
.el-submenu__title i {
    color: #fff;
    padding-right: 20px;
}
.el-menu-item:hover,.el-submenu__title:hover{
    outline: 0;
    background-color: #263445 !important;

}
.el-menu-item:focus,.el-submenu__title:focus{
    outline: 0;
    background-color: #263445 !important;

}
}
    // .rewrite-toolbar{
    //  display: flex;
    // justify-content: space-between;
    // align-items: center;
    // height: 52px;
    // margin-bottom: 0;
    // padding: 0 16px;
    //  box-shadow: 0px 3px 6px 0px rgba(51, 51, 51, 0.1);
    // z-index: 10;
    // margin-bottom: 16px !important;
    // }
</style>